<div class="flex items-center justify-left lg:justify-center p-4">
    <!-- Author: FormBold Team -->
    <div class="mx-auto w-full max-w-[550px] bg-white">


        <h2 class="lg:mt-6 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]">
            Add Your Address
        </h2>

        <div class="max-w-2xl  mx-auto mt-1 mb-10 border-2 border-purple-700 rounded-lg shadow-md shadow-purple-600 "   >
            <div class="flex gap-3 bg-white rounded-xl overflow-hidden items-center justify-start" *ngFor="let address of addressInAddres" >
        
                
                <label class="flex cursor-pointer flex-col  bg-white p-4 pr-8 sm:pr-16" *ngIf="address?.isDefault === true">
                    <h1>default Address</h1>
                    <div class="lg:flex justify-between overflow-hidden">
                        <span class=" text-xl font-semibold" ><b>{{address?.delivery_name}} </b> ({{address?.delivery_mobile}}) <br>
                    <p class="text-lg text-purple-700">{{address?.delivery_address}},{{address?.delivery_city}},{{address?.delivery_pincode}},{{address?.delivery_state}},{{address?.delivery_country}}</p>
                    </span>
   </div>
                     </label>
                
            </div>
        
        </div>
        <form [formGroup]="addressUpdate" (ngSubmit)="addressUpdates()">
            <div class="-mx-3 flex flex-wrap">
                <div class="w-full px-3 sm:w-1/2">
                    <div class="mb-5 ">
                        <label for="fullname"  class="mb-3  block text-base font-medium text-[#07074D] "   >
                            Full Name
                        </label>
                        <input type="text" name="fullname" id="fullname" placeholder="Enter full Name" formControlName="fullName"
                            class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                    </div>
                </div>
                <div class="w-full px-3 sm:w-1/2">
                    <div class="mb-5">
                        <label for="mobilenumber"  class="mb-3 block text-base font-medium text-[#07074D]">
                         Enter Mobile Number
                        </label>
                        <input type="number" formControlName="mobileNumber"  name="mobilenumber" id="mobilenumber" placeholder="Enter Mobile Number" 
                            class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                        </div>
                    </div>
      
                  <div class="w-full px-3 sm:w-1/2">
                    <div class="mb-5">
                        <label for="City" class="mb-3  block text-base font-medium text-[#07074D] "  >
                            City 
                        </label>
                        <input type="text" name="city" formControlName="city" id="City" placeholder="Enter City  " 
                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                </div>
            </div>
            <div class="w-full px-3 sm:w-1/2">
                <div class="mb-5">
                    <label for="Pincode" class="mb-3 block text-base font-medium text-[#07074D]">
                   Pincode
                    </label>
                    <input type="text" formControlName="pinCode" name="Pincode" id="Pincode" placeholder="Enter Pincode" 
                        class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                </div>
            </div>
        </div>

         <!-- Address Type -->
         <div class="mb-5">
            <label for="addressType" class="mb-3 block text-base font-medium text-[#07074D]">
                Address Type
            </label>
            <select formControlName="addressType" id="addressType"
                class="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md">
                <option value="" disabled selected>Select Address Type</option>
                <option value="Home">Home</option>
                <option value="Office">Office</option>
                <option value="Other">Other</option>
            </select>
        </div>

        <!-- Delivery Notes -->
        <div class="mb-5">
            <label for="deliveryNotes" class="mb-3 block text-base font-medium text-[#07074D]">
                Delivery Notes
            </label>
            <textarea formControlName="deliveryNotes" id="deliveryNotes" placeholder="Add any delivery notes (optional)"
                class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"></textarea>
        </div>

        
        <div class="mb-5">
            <label for="guest" class="mb-3 block text-base font-medium text-[#07074D]">
               Country
            </label>
            <select type="email" formControlName="country" (change)="countryselected($event)" name="email" id="email" placeholder="Select State" min="0"
                class="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" >
                <option class="text-black"  value="" disabled selected>Select Country</option>
                <option value="India">India</option>
                <!-- <option value="Pakistan">Pakistan</option> -->
              
            </select>
        </div>
<div class="mb-5">
    <label for="Building" class="mb-3 block text-base font-medium text-[#07074D]">
                    Full Address <p class="text-xs">( eg. building H. No. or company or apartment, village or sector or area, LandMark)</p>
                </label>
                <input type="text" name="Building" formControlName="buildingHouse" id="Building" placeholder="eg. building H. No. or company or apartment, village or sector or area, LandMark" min="0" 
                    class="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
            </div>
            <div class="mb-5">
                <label for="guest" class="mb-3 block text-base font-medium text-[#07074D]">
                   State
                </label>
                <select type="email" formControlName="State" name="email" id="email" placeholder="Select State" min="0"
                    class="w-full appearance-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" >
                    <option value="" disabled selected>Select State</option>
                    <option *ngFor="let state of countries.states" [value]="state.name">{{state.name}}</option>
                    <!-- <option value="Madhya Pradesh">Madhya Pradesh</option>
                    <option>arunachal pradesh</option>
                    <option>asaam</option> -->
                </select>
            </div>

            <div>
                <button  *ngIf="addressIds" 
                    class="btncolor hover:shadow-form rounded-md w-full  py-3 px-8 text-center text-base font-semibold text-white outline-none"  type="submit" [disabled]="addressUpdate.invalid">
                    Update Address
                </button>
                <button *ngIf="!addressIds"
                class="btncolor hover:shadow-form rounded-md w-full  py-3 px-8 text-center text-base font-semibold text-white outline-none"  type="submit" [disabled]="addressUpdate.invalid">
                Add Address
            </button>
            
               
            </div>
        </form>
    </div>
</div>